import { forwardRef, useContext, useEffect } from 'react';
import { TtsContext } from '../../../contexts/TtsContext';
import { AudioTrackContainer } from './styles';
import { useTeams } from '@microsoft/teamsfx-react';

export const AudioTrack = forwardRef<HTMLAudioElement>(function (props, ref) {
  const { context } = useTeams({})[0];

  const { audioUrl, setAudioTrack } = useContext(TtsContext);

  useEffect(() => {
    if (audioUrl) {
      setAudioTrack('');
    }
  }, []);

  return (
    <AudioTrackContainer>
      <audio
        key={'audiotrack-' + audioUrl}
        ref={ref}
        id="speech_player"
        controlsList="nodownload"
        controls
        autoPlay
        src={audioUrl}
        style={{
          colorScheme: context?.app.theme !== 'default' ? 'dark' : 'light',
        }}
      />
    </AudioTrackContainer>
  );
});
